"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constants = require("./constants");
var _constantsGenerated = require("./constants-generated");
var _containers = require("./containers");
var _ErrorBoundary = require("./containers/ErrorBoundary");
var _FooterAppSkeleton = require("./containers/FooterAppSkeleton");
var _FooterContent = require("./containers/FooterContent/FooterContent");
var _contexts = require("./contexts");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file */

const App = ({
  configuration
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
  logger: _logger2.mainLogger,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
      namespace: _constants.translationsNamespace,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.AppConfigProvider, {
        value: configuration,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FooterAppSkeleton.FooterAppSkeleton, {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
            team: _testidGenerator.Team.Presentation,
            project: _constantsGenerated.APP_NAME,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ApiProvider, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FooterContent.FooterContent, {})
            })
          })
        })
      })
    })
  })
});
exports.App = App;